// =============================
// Imports
// =============================

import styled, { css } from 'styled-components';
import { alpha } from '@material-ui/core';

import { ContainerBase, HeaderBase } from '../entity.styles';
import { headerHeight } from '../../presentationals/header/mobile/variables';

// =============================
// Styles
// =============================

export const Container = styled(ContainerBase)`
  padding-top: calc(${headerHeight} + 4rem);

  ${({ theme }) => theme.mediaAbove.minWidth`
    padding-top: 12rem;
  `};

  ${({ theme }) => {
    if (theme.displayConf.playlistImg === 'wide') {
      return css`
        padding: 0;
      `;
    }
    return css``;
  }}
`;

/**
 * When admin choose to display his playlist cover as 'wide',
 * we need to wrap page content with an extra Container, that will
 * add missing padding to the content.
 * */
export const WideContainer = styled(ContainerBase)`
  padding-top: 5rem;
`;

export const Header = styled(HeaderBase)`
  position: relative;

  ${({ theme }) => {
    if (theme.displayConf.playlistImg === 'wide') {
      return css`
        padding: calc(${headerHeight} + 12rem) 1.2rem 5rem 1.2rem;

        ${theme.mediaAbove.minWidth`
          padding-bottom: 4rem;
          padding-top: 31.7rem;
          padding-right: 3rem;
          padding-left: 3rem;
      `};
      `;
    }
    return css`
      flex-direction: column;
      margin-bottom: 5rem;

      ${theme.mediaAbove.minWidth`
        flex-direction: row;
        margin-bottom: 10rem;
      `};
    `;
  }};
`;

export const WideBackground = styled.span.attrs(({ alt }) => ({
  role: 'img',
  'aria-label': alt,
}))`
  background-position: center;
  background-size: cover;
  height: 100%;
  left: 0;
  margin-left: calc(-50vw + 50%);
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: -1;

  ${({ theme, wideBackground }) => (wideBackground
    ? css`
          background-image: linear-gradient(
              0,
              ${alpha(theme.colors.background, 0.6)} 0%,
              ${alpha(theme.colors.background, 0.1)} 100%
            ),
            ${`url(${wideBackground})`};
        `
    : css`
          background: ${alpha(theme.colors.background, 1)};
        `)};
`;
